import React from "react";
import { useQuery } from "@tanstack/react-query";
import { GetLinkedBookings } from "../../../../../APIs/Booking/GetLinkedBookings";
import { useDeviceContext } from "../../../../../context/DeviceContext";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import Loading from "../../../../../utils/Loading";
import Table from "../../../../Shared/Table/Table";
import SelectedBookingPayments from "../Payments/SelectedBookingPayments";
import { SelectedBookingTabEnum } from "../Tabs/SelectedBookingTabsController";
import {
  getLinkedBookingDetails,
  mapLinkedBookingsTableData
} from "./SelectedBookingLinkedController";

type SelectedBookingLinkedType = {
  setSelectedTabKey: (value: SelectedBookingTabEnum) => void;
};
const SelectedBookingLinked = ({
  setSelectedTabKey
}: SelectedBookingLinkedType) => {
  const diaryContext = useDiaryContext();
  const { connectionStatus } = useDeviceContext();

  const selectedBookingId = diaryContext.selectedBooking?.id ?? "";

  const { data: linkedBookingsRefData, isLoading } = useQuery({
    queryKey: ["GetLinkedBookings", selectedBookingId],
    queryFn: () => GetLinkedBookings(selectedBookingId)
  });

  const { data: linkedBookingsData, isLoading: isLoading2 } = useQuery({
    queryKey: ["linkedBookingDetailsData", linkedBookingsRefData?.toString()],
    queryFn: () =>
      getLinkedBookingDetails({
        linkedBookingIds: linkedBookingsRefData,
        diaryContext
      })
  });

  const linkedBookingsTableData = mapLinkedBookingsTableData({
    bookings: linkedBookingsData,
    diaryContext,
    setSelectedTabKey
  });

  const loading =
    (!linkedBookingsTableData || linkedBookingsTableData.length === 0) &&
    (isLoading || isLoading2) &&
    connectionStatus === "internet";

  return (
    <div className="SelectedBookingLinkedContainer mt-panel-padding flex flex-wrap">
      <div className="LinkedBookings-Heading font-bold m-panel-padding text-[length:var(--fontSize-base)]">
        Linked Bookings
      </div>
      <div className="LinkedBookings mt-panel-padding flex-[1_1_100%] flex flex-col">
        <Table
          columns={[
            {
              caption: "DMN Ref #",
              dataNameJSX: "reference"
            },
            {
              caption: "Type",
              dataName: "typeName"
            },
            {
              caption: "Site",
              dataName: "site"
            },
            {
              caption: "Time",
              dataName: "time"
            },
            {
              caption: "Date",
              dataName: "date"
            },
            {
              caption: "Duration",
              dataName: "duration"
            },
            {
              caption: "Status",
              dataNameJSX: "status"
            },
            {
              caption: "Area",
              dataName: "area"
            }
          ]}
          data={linkedBookingsTableData ?? []}
        />
        {loading && <Loading />}
        {!loading &&
          linkedBookingsTableData &&
          linkedBookingsTableData.length === 0 &&
          diaryContext.selectedBooking && (
            <span className="NoRecords p-panel-padding m-auto">
              No linked bookings found.
            </span>
          )}
      </div>
      <div className="LinkedPayments mt-panel-padding flex-[1_1_100%] flex flex-col">
        {linkedBookingsRefData && (
          <SelectedBookingPayments
            linkedBookingIds={linkedBookingsRefData ?? []}
            setSelectedTabKey={setSelectedTabKey}
          />
        )}
      </div>
    </div>
  );
};

export default SelectedBookingLinked;
